import { getUserRole } from './userLocalDetails';
import { isNullOrEmpty } from './utils/arrays';
import { useActiveClassData } from './components/state/hooks';

export const userRole = () => {
  const { data: classData, isLoadingdata: isLoadingclassData } = useActiveClassData();
  const isTeacher = getUserRole() === 'TEACHER';
  if (isTeacher) {
    return 'TEACHER';
  }

  return isNullOrEmpty(classData) ? 'NONSCHOOLSTUDENT' : 'STUDENT';
};
